"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeeplyOptimizedValue = exports.deepCopyCustomizations = void 0;

var _1 = require(".");

function deepCopyCustomizations(x) {
  var e_1, _a;

  var val = x;

  if (typeof val !== "object" || val === null) {
    return val;
  }

  if (_1.isCustoClass(val)) return val;

  if (val instanceof Date) {
    return new Date(val);
  }

  var newVal = Array.isArray(val) ? [] : {};
  var keys = Object.keys(val);

  try {
    for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
      var key = keys_1_1.value;
      newVal[key] = deepCopyCustomizations(val[key]);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return newVal;
}

exports.deepCopyCustomizations = deepCopyCustomizations;

exports.getDeeplyOptimizedValue = function (oldValue, newValue, skipFn) {
  if (oldValue === newValue) return newValue;
  if (typeof oldValue !== typeof newValue) return newValue;
  if (typeof oldValue !== "object" || oldValue === null) return newValue;

  if (skipFn) {
    var decision = skipFn(oldValue, newValue);

    if (!decision.skip) {
      if (decision.leaveOld) return oldValue;
      return newValue;
    }
  }

  var oldKeys = Object.keys(oldValue).sort();
  var newKeys = Object.keys(newValue).sort();
  var copiedNewVal = Array.isArray(newValue) ? __spread(newValue) : __assign({}, newValue);
  var canOldValueBeUsed = true;

  for (var i = 0; i < oldKeys.length; i++) {
    var key = oldKeys[i];
    if (key !== newKeys[i]) canOldValueBeUsed = false;
    var oldPropValue = oldValue[key];
    var newPropValue = newValue[key];
    var newVal = exports.getDeeplyOptimizedValue(oldPropValue, newPropValue, skipFn);
    if (oldPropValue !== newVal) canOldValueBeUsed = false;
    copiedNewVal[key] = newVal;
  }

  if (oldKeys.length !== newKeys.length) canOldValueBeUsed = false;
  if (canOldValueBeUsed) return oldValue;
  return copiedNewVal;
};